import Tabs from './tabs';
import Pagination from './pagination';
import Breadcrumb from './breadcrumb';
import BlueTitle from './blue-title.vue';
import Headertip from './header-tip';

const install = Vue => {
  if (install.installed) return;
  Vue.component(Tabs.name, Tabs);
  Vue.component(Pagination.name, Pagination);
  Vue.component(Breadcrumb.name, Breadcrumb);
  Vue.component(BlueTitle.name, BlueTitle);
  Vue.component(Headertip.name, Headertip);
};
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
export default install;
